<template>
  <div>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-card class="elevation-12">
            <v-toolbar class="black--text" :color="this.$store.getters.stdColorLight" flat>
              <v-row justify="center">
                <v-toolbar-title>
                  <span v-html="$t('message.loginDialog')+' '+$t('message.optimaw')"></span>
                </v-toolbar-title>
              </v-row>
            </v-toolbar>
            <v-card-text>
              <v-form>
                <v-text-field :label="$t('message.benutzer')" v-model="actualUser.username" prepend-icon="person" type="text"></v-text-field>
                <v-text-field
                  :label="$t('message.passwort')"
                  v-model="actualUser.password"
                  prepend-icon="lock"
                  type="password"
                ></v-text-field>
                <v-textarea v-if="this.sendPasswordState" v-model="eMail.returnMessage" class="subtitle-2" rows="2" disabled></v-textarea>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="white--text" :color="this.$store.getters.stdColorDark" :disabled="registerInactive" @click="register(actualUser.username)">{{ $t("message.register") }}</v-btn>
              <v-btn class="white--text" :color="this.$store.getters.stdColorDark" :disabled="sendPasswordInactive" @click="sendNewPassword(actualUser.username)">{{ $t("message.sendNewPassword") }}</v-btn>
              <v-btn class="white--text" :color="this.$store.getters.stdColorDark" @click="handleLogon(actualUser.username,actualUser.password)">Login</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import WebService from "@/plugins/WebService";
import EntityHelper from "@/plugins/EntityHelper";

export default {
  name: "user-login",

  data() {
    return {
      webService: null,
      entityHelper: null,

      actualUser: {
        username: "",
        password: ""
      },

      eMail: {
        recipient: "",
        subject: "",
        message: "",
        returnState: false,
        returnMessage: ""
      },
      sendPasswordInactive: true,
      sendPasswordState: false,

      registerInactive: true,

      errorState: null
    };
  },
  
  created() {
    this.webService=new WebService(this);
    this.entityHelper = new EntityHelper(this);
  },

  methods: {
    handleLogon: function(username, password) {
      this.sendPasswordState = false;
      this.$store.dispatch("setActualUser", this.actualUser);
      this.webService
        .login(this.$store.getters.login, username, password)
        .then(response => {
          if (response.request.status == 200)
          {
            // get user data
            this.webService
              .getUser(this.$store.getters.getUser, username)
              .then(response => {
                if (response.request.status == 200)
                {
                  this.$store.dispatch("setUser", response.data);

                  // set initial screen
                  this.webService.getItem(this.$store.getters.paramsBase,[username])
                    .then(response => {
                      this.$store.dispatch("setTaxCode", response.data.stCode);
                      this.setInitialScreen(response.data.displayObject)
                    })
                    .catch(err => { console.log(err) });

                  // create log entry
                  var logEntry= {
                    id: 0,
                    mid: "",
                    ts: "",
                  }
                  logEntry.mid = response.data.username;
                  logEntry.ts = new Date().toISOString().slice(0, 19).replace('T', ' ');
                  this.webService
                    .createLogEntry(this.$store.getters.createLogEntry, logEntry)
                    .then(response => {
                      if (response.request.status != 201)
                      {
                        console.log(response.request.status)
                      }
                    })
                    .catch(err => {
                      console.log(err)
                    });
                }
                else
                  this.$store.dispatch("setUser", {});
              });

            this.$store.dispatch('setNavigationDrawer');
            this.$store.dispatch('setSystemBarColor', this.$store.getters.colorSystemBarOn);
            this.$store.dispatch("setLoggedOn", true);
          }
          else
          {
            this.$store.dispatch("setUser", {});
            this.$store.dispatch("setLoggedOn", false);
          }
        })
        .catch(err => {
          this.errorState=err;
        })
        .finally(() => {
          this.actualUser.username="";
          this.actualUser.password="";
        });
    },

    checkUsername(username)
    {
      this.sendPasswordInactive=true;
      this.registerInactive=true;
      if (username==null)
      {
        return;
      }

      if (username.includes("@") && username.includes("."))
      {
      this.webService
        .getUserNoAuth(this.$store.getters.getUserNoAuth, username)
        .then(response => {
          if (response.request.status == 200)
          {
            if (response.data.username!=null)
            {
              if(response.data.username==username)
              {
                this.sendPasswordInactive=false;
                this.registerInactive=true;
              }
              else
                this.registerInactive=false;
            }
          }
        });
      }
      return;
    },

    sendNewPassword(username)
    {
      this.eMail.recipient = username;
      this.eMail.subject = this.$t("message.newPWSubject");
      this.eMail.message = this.$t("message.newPWMessage") + this.$t("message.mailText2");

      //send new password
      this.webService
        .issueNewPassword(this.$store.getters.issueNewPassword, this.eMail)
        .then(response => {
          this.sendPasswordState = response.data.returnState;
          this.eMail = response.data;
          if (this.eMail.returnState)
            this.eMail.returnMessage = this.$t("message.newPWConfirmation");
        })
        // eslint-disable-next-line
        .catch(err => {
          this.eMail.returnMessage = "Mail: REST API Error";
          this.eMail.returnState = false;
          this.sendPasswordState = false;
        });
    },

    register(username)
    {
      this.actualUser.username=username;
      this.$store.dispatch("setActualUser", this.actualUser);
      this.$store.dispatch("setShowRegisterProcess", true);
    },

    setInitialScreen(initialObject)
    {
      switch (initialObject) {
        case 'Kunden':
          this.entityHelper.setCustomerState(true)
          break;
        case 'Artikel':
          this.entityHelper.setProductState(true)
          break;
        case 'Leistungen':
          this.entityHelper.setServiceState(true)
          break;
        case 'Fakturen':
          this.entityHelper.setFakturaState(true, this.$store.getters.FAKTURA_FAKTURA)
          break;
        case 'Offerten':
          this.entityHelper.setFakturaState(true, this.$store.getters.FAKTURA_OFFERTE)
          break;
        case 'Aufträge':
          this.entityHelper.setFakturaState(true, this.$store.getters.FAKTURA_AUFTRAG)
          break;
        case 'Rapporte':
          this.entityHelper.setFakturaState(true, this.$store.getters.FAKTURA_RAPPORT)
          break;
        default:
          console.log('wrong param');
      }
    }

  },

  watch: {
    'actualUser.username': {
      // eslint-disable-next-line
      handler(newVal, oldVal) {
        this.checkUsername(newVal);
      }
    }

  }

};
</script>

<style scoped>
</style>
